import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudTransfer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-transfer, move-data, move-cloud-files"><path d="M13.025 18.25H6.875C4.04454 18.25 1.75 15.9555 1.75 13.125C1.75 10.529 3.68024 8.38374 6.18382 8.04624C7.0149 5.63348 9.30501 3.90002 12 3.90002C15.3966 3.90002 18.15 6.65347 18.15 10.05C20.4144 10.05 22.25 11.8857 22.25 14.15C22.25 16.4144 20.4144 18.25 18.15 18.25H17.6375" stroke="currentColor" strokeWidth="1.5"/><path d="M10.5 14.75L14 18.25L10.5 21.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCloudTransfer;
